module.exports = __webpack_public_path__ + "static/media/edit.9c2ceff3.svg";